import React, {memo, useState, useEffect} from 'react';
import {i_chat_period, i_chat_period_red} from '../../../icons';
import {InputRadioFilter} from '../../../utils/radio/InputRadioFilter';
import {InputUserForm} from "../../../utils/input/InputUserForm";
import {InputDebounceUserForm} from "../../../utils/input/InputDebounceUserForm";
import {
  coursePeriods,
  coursePeriodsWeek,
  roleChiefNutritionist,
  userPrintName,
  formatErrors,
  roleCurator,
  userStatusFired, userStatusDayOff, coursePeriodsDetox, coursePeriodsMarathon
} from "../../../constants";
import {useSelector, useDispatch} from "react-redux";
import {curatorsAction} from '../../../actions/usersAction';
import {toast} from "react-toastify";

function ChatListPeriod({filter, totals, handleChange}) {
  const onPeriodTypeChange = (field, value) => {
    let period_from = '', period_to = '';
    let now = new Date(), dt;
    switch (value) {
      case 'today':
        dt = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        period_from = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);
        period_to = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);
        handleChange(field, value, {period_type: value, period_from, period_to});
        break;
      case 'yesterday':
        dt = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        period_from = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);
        period_to = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2);
        handleChange(field, value, {period_type: value, period_from, period_to});
        break;
      case 'manual':
        handleChange(field, value, {period_type: value, period_from, period_to});
        break;
      default:
        handleChange(field, '', {period_type: '', period_from, period_to});
    }
  };

  const onPeriodChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange(name, value);
  };
  
  const user = useSelector(state => state.user.profile);
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  
  useEffect(() => {
    dispatch(curatorsAction()).then((data) => {
      let list = [{ key: '', text: 'Все', value: '' }];
      (data || []).forEach((i) => {
        let name = userPrintName(i);
        list.push({key: i.id, text: name, value: i.id, role_id: i.role_id, status: i.status});
      });
      setUsers(list);
    }).catch((e) => {
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  return <div className="sidebar-chat__dropdown">
    <button type="button" className={"sidebar-chat__icon" + ((filter.period_from || filter.period_to || (filter.length_msg && (filter.length_from || filter.length_to)) || filter.program_stage > -1 || filter.last_message > 0 || filter.added_to_chat > 0 || filter.control || filter.curator_id) ? " sidebar-chat__icon--active" : "")}>
      {(filter.period_from || filter.period_to || (filter.length_msg && (filter.length_from || filter.length_to)) || filter.program_stage > -1 || filter.last_message > 0 || filter.added_to_chat > 0 || filter.control || filter.curator_id) ? i_chat_period_red():i_chat_period()}
    </button>
    <ul className="dropdown">
      <li className="dropdown__item">
        <InputRadioFilter type="checkbox" value="today" checked={filter.period_type === "today"} text="Сегодня" count={totals && totals['today'] ? totals['today'] : ''} name="period_type" onChange={onPeriodTypeChange}/>
      </li>
      <li className="dropdown__item">
        <InputRadioFilter type="checkbox" value="yesterday" checked={filter.period_type === "yesterday"} text="Вчера" count={totals && totals['yesterday'] ? totals['yesterday'] : ''} name="period_type" onChange={onPeriodTypeChange}/>
      </li>
      <li className="dropdown__item">
        <InputRadioFilter type="checkbox" value="manual" checked={filter.period_type === "manual"} text="Выбрать период" count="" name="period_type" onChange={onPeriodTypeChange}/>
        {filter.period_type === "manual" && <React.Fragment>
          <div className="tabs__inner">
            <div className="tabs__heading">От</div>
            <div className="tabs__value">
              <InputUserForm value={filter.period_from} name="period_from" placeholder="От" type="date" onChange={onPeriodChange} />
            </div>
          </div>
          <div className="tabs__inner">
            <div className="tabs__heading">До</div>
            <div className="tabs__value">
              <InputUserForm value={filter.period_to} name="period_to"  placeholder="По" type="date" onChange={onPeriodChange} />
            </div>
          </div>
        </React.Fragment>}
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <InputRadioFilter type="checkbox" value={true} checked={filter.length_msg} text="Длина сообщения" count="" name="length_msg" onChange={handleChange}/>
        {filter.length_msg && <React.Fragment>
          <div className="tabs__inner">
            <div className="tabs__heading">От</div>
            <div className="tabs__value">
              <InputDebounceUserForm value={filter.length_from} name="length_from" placeholder="От" type="number" onChange={handleChange} />
            </div>
          </div>
          <div className="tabs__inner">
            <div className="tabs__heading">До</div>
            <div className="tabs__value">
              <InputDebounceUserForm value={filter.length_to} name="length_to"  placeholder="До" type="number" onChange={handleChange} />
            </div>
          </div>
        </React.Fragment>}
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <select name="program_stage"
                className="tabs__select select"
                value={filter.program_stage}
                onChange={(e) => handleChange('program_stage', 1 * e.target.value)}>
          <option value={-1}>Этап программы</option>
          {coursePeriods.map((i, k) => <option key={k} value={i.id}>{i.title}</option>)}
        </select>
      </li>

      {filter.program_stage > coursePeriodsDetox && <li className="dropdown__item dropdown__item--separator">
            <select name="program_stage_week"
                    className="tabs__select select"
                    value={filter.program_stage_week}
                    onChange={(e) => handleChange('program_stage_week', 1 * e.target.value)}>
                <option value={-1}>Неделя программы</option>
                {coursePeriodsWeek.map((i, k) => {
                  return <React.Fragment key={k}>
                    {filter.program_stage < coursePeriodsMarathon && k < 2 && <option key={k} value={i.id}>{i.title}</option> }
                    {filter.program_stage >= coursePeriodsMarathon && <option key={k} value={i.id}>{i.title}</option> }
                  </React.Fragment>
                })}
            </select>
        </li>}

      {user && user.role_id === roleChiefNutritionist && <li className="dropdown__item dropdown__item--separator">
        <select name="curator_id"
                className="tabs__select select"
                value={filter.curator_id}
                onChange={(e) => handleChange('curator_id', e.target.value)}>
          <option value="">Выберите куратора</option>
          {users.map(i => i.value && (i.role_id === roleCurator) && (i.status !== userStatusFired) && <option key={i.value} value={i.value}>{i.text}{i.status === userStatusDayOff ? ' (Выходной)':''}</option>)}
        </select>
      </li>}
      
      <li className="dropdown__item dropdown__item--separator">
        <select name="last_message"
                className="tabs__select select"
                value={filter.last_message}
                onChange={(e) => handleChange('last_message', 1 * e.target.value)}>
          <option value={0}>Последнее сообщение</option>
          <option value={2}>2 дня</option>
          <option value={3}>3 дня</option>
        </select>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <select name="added_to_chat"
                className="tabs__select select"
                value={filter.added_to_chat}
                onChange={(e) => handleChange('added_to_chat', 1 * e.target.value)}>
          <option value={0}>Добавились в чат</option>
          <option value={1}>1 день</option>
          <option value={2}>2 дня</option>
          <option value={3}>3 дня</option>
        </select>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <InputRadioFilter type="checkbox" value={true} checked={filter.control} text="Контроль" count={totals && totals['control'] ? totals['control'] : ''} name="control" onChange={handleChange}/>
      </li>
      <li className="dropdown__item dropdown__item--separator">
        <InputRadioFilter type="checkbox" value={true} checked={filter.archive} text="Архив" count="" name="archive" onChange={handleChange}/>
      </li>
    </ul>
  </div>;
};

export default memo(ChatListPeriod, (prevProps, nextProps) => {
  return prevProps.filter.period_type === nextProps.filter.period_type &&
    prevProps.filter.period_from === nextProps.filter.period_from &&
    prevProps.filter.period_to === nextProps.filter.period_to &&
    prevProps.filter.control === nextProps.filter.control &&
    prevProps.filter.length_msg === nextProps.filter.length_msg &&
    prevProps.filter.length_from === nextProps.filter.length_from &&
    prevProps.filter.length_to === nextProps.filter.length_to &&
    prevProps.filter.program_stage === nextProps.filter.program_stage &&
    prevProps.filter.program_stage_week === nextProps.filter.program_stage_week &&
    prevProps.filter.last_message === nextProps.filter.last_message &&
    prevProps.filter.added_to_chat === nextProps.filter.added_to_chat &&
    prevProps.filter.archive === nextProps.filter.archive &&
    prevProps.totals.today === nextProps.totals.today &&
    prevProps.totals.yesterday === nextProps.totals.yesterday &&
    prevProps.totals.control === nextProps.totals.control &&
    prevProps.filter.curator_id === nextProps.filter.curator_id
});
